export const showLoader = (e) => {
    let x = document.getElementById('loader-full');
    x.style.display = e;
}